import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import gettingBioLinkService from './getLinkService';

// Get user from

const initialState = {
  getBioLink: '',
  getBioLinkError: false,
  getBioLinkSuccess: false,
  getBioLinkLoading: false,
  getBioLinkErrorMsg: '',
};

// creating____________bioLink____________________
export const gettingBioLink = createAsyncThunk(
  'getBioLink/gettingBioLink',

  async (_, thunkAPI) => {
    try {
      const response = await gettingBioLinkService.gettingBioLink();
      return response;
      // getting getlink data from getlink services
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const getBioLinkErrorMsg =
        (error.response && error.response.data && error.response.data.getBioLinkErrorMsg) ||
        error.getBioLinkErrorMsg ||
        error.toString();
      //         if(error.response?.status === 498){
      //           localStorage.clear()
      //           window.location.href = "/auth/login";
      // }
      return thunkAPI.rejectWithValue(getBioLinkErrorMsg);
    }
  }
);

export const openMainScreen = createAsyncThunk(
  'getBioLink/openMainScreen',

  async (username, thunkAPI) => {
    try {
      return await gettingBioLinkService.openMainScreen(username); // getting getlink data from getlink services
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const getBioLinkErrorMsg =
        (error.response && error.response.data && error.response.data.getBioLinkErrorMsg) ||
        error.getBioLinkErrorMsg ||
        error.toString();

      return thunkAPI.rejectWithValue(getBioLinkErrorMsg);
    }
  }
);
export const gettingBioLinkSlice = createSlice({
  // handle the api response(promise coming from api) , either
  name: 'getBioLink',
  initialState,
  reducers: {
    resetLink: (state) => {
      state.getBioLinkSuccess = false;
      state.getBioLinkError = false;
      state.getBioLinkLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gettingBioLink.pending, (state) => {
        state.getBioLinkLoading = true;
      })
      .addCase(gettingBioLink.fulfilled, (state, action) => {
        state.getBioLinkLoading = false;
        state.getBioLinkSuccess = true;
        state.getBioLink = action.payload;
      })
      .addCase(gettingBioLink.rejected, (state, action) => {
        state.getBioLinkLoading = false;
        state.getBioLinkError = true;
        state.getBioLinkErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      });
  },
});

export const { resetLink } = gettingBioLinkSlice.actions;
export default gettingBioLinkSlice.reducer;
